import { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorNeutralGrey4, ColorNordicGrey5, Spacing8, Spacing24 } from 'autogen/design-tokens/tokens';
import { Show } from 'autogen/translation-keys/trans-website-filter';
import { ShowAll } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import { closeAllDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import Flex from 'components/Layout/components/Flex';
import useFilters from '../../../shared/hooks/useFilters';
import { FilterMenuDataContext } from '../../Filters/FilterMenuRenderer';
import ApplyFiltersButton from './ApplyFiltersButton';
import ResetFiltersButton from './ResetFiltersButton';

/* #region styles */
const StyledFlexColumn = styled(Flex.Column)`
    background-color: ${ColorNordicGrey5};
    border-top: 1px solid ${ColorNeutralGrey4};
    padding: ${Spacing24};
`;
/* #endregion */

const FilterMenuFooter = () => {
    const { hasPendingFilters } = useFilters();
    const {
        productList: { activeFilterValues }
    } = useContext(FilterMenuDataContext);
    const hasActiveFilters = !!activeFilterValues.length;
    const hasAnyFilters = hasPendingFilters || hasActiveFilters;

    if (!hasAnyFilters) return null;

    return (
        <StyledFlexColumn gap={Spacing8}>
            {hasPendingFilters && <ApplyFiltersButton />}
            {hasAnyFilters && <ResetFiltersButton />}
        </StyledFlexColumn>
    );
};

export default memo(FilterMenuFooter);

export function FilterMenuFooterSimple() {
    const { hasPendingFilters, applyPendingFilters } = useFilters();
    const { t } = useTranslation();

    const handleApplyFilters = () => {
        applyPendingFilters();
        closeAllDrawers();
    };

    if (!hasPendingFilters) return null;

    return (
        <StyledFlexColumn gap={Spacing8}>
            {hasPendingFilters && (
                <Button size="lg" onClick={handleApplyFilters}>
                    {t(Show)}
                </Button>
            )}
        </StyledFlexColumn>
    );
}
